import { baseApi } from './baseApi';
import { decodeAccountByIdApiResponseFull, type AccountByIdApiResponseFull } from './apiSchema';
import { mapToDomain, mapToRest, type Account } from '../app/companySettings/types';

export const accountsApi = baseApi.injectEndpoints({
    endpoints: build => ({
        getAccount: build.query<Account, { accountId: string; tokenOverride?: string }>({
            query: ({ accountId, tokenOverride }) => ({
                service: 'accounts',
                path: `/${accountId}`,
                tokenOverride,
            }),
            transformResponse: response => mapToDomain(decodeAccountByIdApiResponseFull(response)),
            providesTags: (_result, _error, { accountId }) => [{ type: 'Account', id: accountId }],
        }),
        updateAccount: build.mutation<void, Account>({
            query: account => ({
                service: 'accounts',
                path: `/${account.id}`,
                method: 'PUT',
                body: mapToRest(account),
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                },
            }),
            invalidatesTags: (_result, _error, account) => [{ type: 'Account', id: account.id }],
        }),
        getRawAccount: build.query<AccountByIdApiResponseFull, { accountId: string; tokenOverride?: string }>({
            query: ({ accountId, tokenOverride }) => ({
                service: 'accounts',
                path: `/${accountId}`,
                tokenOverride,
            }),
            transformResponse: response => decodeAccountByIdApiResponseFull(response),
            providesTags: (_result, _error, { accountId }) => [{ type: 'Account', id: accountId }],
        }),
    }),
});

export const { useGetAccountQuery, useLazyGetAccountQuery, useUpdateAccountMutation } = accountsApi;
